import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  className = '',
  type = 'button',
  disabled = false,
}) => (
  <button
    type={type}
    onClick={onClick}
    className={`py-2 px-4 bg-[#21338e] text-white rounded-full shadow focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 ${className}`}
    disabled={disabled}
  >
    {children}
  </button>
);

export default Button;
